import PropTypes from "prop-types"
import { Autocomplete, TextField } from "@mui/material"
import { DROPDOWN_OPTION } from "helpers/shapes"

export default function SingleSelectFilter({ values, options, setValues, disabled }) {
  const handleSetValue = (_, value) => {
    setValues(value)
  }

  return <Autocomplete
    options={options}
    value={values[0] === undefined ? null : values[0]}
    blurOnSelect
    clearOnBlur
    disableClearable
    disabled={disabled}
    isOptionEqualToValue={(option, value) => option.value === value.value}
    onChange={handleSetValue}
    slotProps={{
      popper: {
        sx: {
          minWidth: "fit-content",
        },
        placement: "bottom-start",
      },
    }}
    renderInput={(params) => <TextField
      {...params}
      variant="standard"
      placeholder="Select..."
    />}
  />
}

SingleSelectFilter.propTypes = {
  values: PropTypes.arrayOf(DROPDOWN_OPTION).isRequired,
  options: PropTypes.arrayOf(DROPDOWN_OPTION).isRequired,
  setValues: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
